const EquipmentReport = () =>
  import(
    /* webpackChunkName: "base-info-courier-equipment" */ '@/pages/base-info/courier/equipment/index.vue'
  )
const CreateCourierEquipment = () =>
  import(
    /* webpackChunkName: "base-info-courier-equipment" */ '@/pages/base-info/courier/equipment/create.vue'
  )
const EditCourierEquipment = () =>
  import(
    /* webpackChunkName: "base-info-courier-equipment" */ '@/pages/base-info/courier/equipment/edit.vue'
  )

export default {
  path: 'equipment',
  meta: {
    label: 'equipment',
    auth: 'equipment'
  },
  component: {
    name: 'Equipment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCourierEquipment',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: EquipmentReport
    },
    {
      name: 'BaseInfoCreateCourierEquipment',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCourierEquipment
    },
    {
      name: 'BaseInfoEditCourierEquipment',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCourierEquipment,
      props: true
    }
  ]
}
